import React, { useEffect, useRef } from "react";

export interface IUser {
  exp: number;
  iat: number;
  uid: string;
  typ: number;
}

import geoIcon from "../../assets/geo.svg";

import style from "./map.module.scss";
import { mapService } from "../../services/mapService/googleMapService";

export const Map = (props) => {
  const { stores } = props;
  const mapElement = useRef<HTMLDivElement>(null);
  useEffect(() => {
    mapService.init(mapElement.current, {
      zoom: 8,
      disableDefaultUI: true,
      center: new google.maps.LatLng(45.472996, 12.225231),
    });

    navigator.geolocation.getCurrentPosition(({ coords }) => mapService.panTo(new google.maps.LatLng( coords.latitude, coords.longitude), false));

    stores.forEach((store) => {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(store.coords[0], store.coords[1]),
        title: store.name,
        map: mapService.getInstance(),
        icon: {
          url: geoIcon,
          size: new google.maps.Size(32, 32),
          scaledSize: new google.maps.Size(32, 32),
        },
      });
      marker.addListener("click", () => {
        // @ts-ignore
        mapService.panTo(marker.getPosition(), true);
        props.onClick(store);
      });
    });
    return () => {
      mapService.clear();
    };
  }, [ stores ]);

  return (<div ref={mapElement} className={style["map-wrapper"]} />);
};
